import React from "react";

import logoRcm from "../../../assets/logo_rcm.jpg";
import { Link } from "react-router-dom";

const HeaderBlog = () => {
	return (
		<header className="header-blog">
			<div className="header-blog__container">
				<div className="header-blog__left">
					<Link to="/">
						<img src={logoRcm} alt="Logo rc" className="header-blog__logo" />
					</Link>
				</div>

				<div className="header-blog__rigth">
					{/* <Button type="button" color="green" design="line">
						Sign in
					</Button> */}
					{/* <Link to="/about/" className="btn green line">
						Profile
					</Link> */}
				</div>
			</div>
		</header>
	);
};

export default HeaderBlog;
